import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { ChipMap } from '../chipMap';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';
import Nav from './Nav';
import styles from './index.css';
import MainSwiper from '@src/pc/index/layout/MainSwiper';
import Awards from '@src/pc/index/layout/Awards';
import News from '@src/pc/index/layout/components/News';
import ArticleList from '@src/pc/index/layout/components/ArticleList';
import Banner from '@src/pc/index/layout/components/Banner';
import LargeSwiper from '@src/pc/index/layout/LargeSwiper';
import GridBox from '@src/pc/index/layout/GridBox';
import ImageArticle from '@src/pc/index/layout/components/ImageArticle';
import NewsList from '@src/pc/index/layout/NewsList';
import SlideSwiper from '@src/pc/index/layout/SlideSwiper';
import SmallBanner from '@src/pc/index/layout/components/SmallBanner';
import SmallBannerC from '@src/pc/index/layout/components/SmallBannerC';
import GridList from '@src/pc/index/layout/components/GridList';
import Support from '@src/pc/index/layout/Support';
import Footer from '@src/common/Footer';
import banner from './img/navbg.png';

const Layout = ({ content }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [notShowList, setNotShowList] = useState([]);

    const onChangeActiveIndex = (e) => {
        const { index } = e.currentTarget.dataset;

        setActiveIndex(+index);
    };

    useEffect(() => {
        const layout = content['Layout'];

        for (const i of layout) {
            const { id, isShow } = i;
            const list = notShowList.slice();

            if (!isShow) {
                list.push(id);
            }
            setNotShowList(list);
        }
    }, []);

    return (
        <div className={styles.layout}>
            <Chip key="Layout" {...ChipMap.Layout} content={content['Layout']}>
                <div />
            </Chip>
            <div className={styles.mainImage}>
                <img className={styles.banner} src={banner} alt="主图" />
                {/* <img className={styles.logo} src="https://x0.ifengimg.com/ucms/2022_03/AAFC5F823EF8EF945EA1B79E503325864565CBF1_size42_w700_h50.png" alt="logo" /> */}
            </div>
            <Chip key="Nav" {...ChipMap.Nav} content={content['Nav']}>
                <Nav />
            </Chip>
            <div className={styles.main}>
                <div className={styles.box}>
                    <Chip key="MainSwiper" {...ChipMap.MainSwiper} content={content['MainSwiper']}>
                        <MainSwiper />
                    </Chip>
                    <Awards />
                </div>
                <div className={styles.box}>
                    <div>
                        <Chip key="NewList1" {...ChipMap.NewList1} content={content['NewList1']}>
                            <News />
                        </Chip>
                        <Chip key="NewList2" {...ChipMap.NewList2} content={content['NewList2']}>
                            <News />
                        </Chip>
                        <Chip key="NewList3" {...ChipMap.NewList3} content={content['NewList3']}>
                            <News />
                        </Chip>
                    </div>
                    <div>
                        <Chip key="SmallBanner1" {...ChipMap.SmallBanner1} content={content['SmallBanner1']}>
                            <SmallBanner />
                        </Chip>
                        <Chip key="ArticleList1" {...ChipMap.ArticleList1} content={content['ArticleList1']}>
                            <ArticleList />
                        </Chip>
                        <Chip key="SmallBanner2" {...ChipMap.SmallBanner2} content={content['SmallBanner2']}>
                            <SmallBannerC />
                        </Chip>
                        <Chip key="ArticleList2" {...ChipMap.ArticleList2} content={content['ArticleList2']}>
                            <ArticleList />
                        </Chip>
                    </div>
                </div>
                <div className={`${styles.box} ${styles.block}`}>
                    <Chip key="Banner2" {...ChipMap.Banner2} content={content['Banner2']}>
                        <Banner />
                    </Chip>
                    <Chip key="GridBox" {...ChipMap.GridBox} content={content['GridBox']}>
                        <GridBox />
                    </Chip>
                </div>
                <div className={`${styles.box} ${styles.block}`}>
                    <Chip key="Banner3" {...ChipMap.Banner3} content={content['Banner3']}>
                        <Banner />
                    </Chip>
                    <Chip key="ImageArticle" {...ChipMap.ImageArticle} content={content['ImageArticle']}>
                        <ImageArticle />
                    </Chip>
                </div>
                <div className={`${styles.box} ${styles.block}`}>
                    <Chip key="Banner4" {...ChipMap.Banner4} content={content['Banner4']}>
                        <Banner />
                    </Chip>

                    <Chip key="NewList4" {...ChipMap.NewList4} content={content['NewList4']}>
                        <NewsList />
                    </Chip>
                </div>

                {!notShowList.includes('support') && (
                    <div id="support" className={`${styles.box} ${styles.block}`}>
                        <Chip key="Banner5" {...ChipMap.Banner5} content={content['Banner5']}>
                            <Banner />
                        </Chip>
                        <Chip key="Support" {...ChipMap.Support} content={content['Support']}>
                            <Support />
                        </Chip>
                    </div>
                )}
                <Footer data={content.footer} />
            </div>
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
